import axios from "axios";
import { config } from "../config/env";
import { setupRefreshTokenInterceptor } from "../helpers/axiosRefreshInterceptor";

const API_URL = config.api.baseUrl;
console.log("config : ", config)
console.log("api url in axios", API_URL)
if (!API_URL) {
  console.warn("API_URL is not defined in .env file.");
} else {
}

console.log("API URL : " ,API_URL)
export const Axios = axios.create({
  baseURL: API_URL,
  // withCredentials: true, // Uncomment if using cookies/sessions
  headers: {
    "Content-Type": "application/json",
  },
});

Axios.interceptors.request.use(
  (request) => {
    try {
      const user_data = localStorage.getItem("authUser");

      if (user_data) {
        const parsed = JSON.parse(user_data);
        const TOKEN = parsed?.access;
        // console.log("token => ",TOKEN);
        if (TOKEN) {
          request.headers.Authorization = `Bearer ${TOKEN}`;
        } else {
          console.warn("No access token found in authUser.");
        }
      } else {
        console.warn(" No authUser found in localStorage.");
      }

      // If FormData, let browser set Content-Type with boundary
      if (request.data instanceof FormData) {
        delete request.headers["Content-Type"];
      } else {
        // console.log("Axios interceptor: Not FormData, data type:", typeof request.data, request.data?.constructor?.name);
      }

      return request;
    } catch (err) {
      console.error("Failed to parse token from localStorage:", err);
      return request;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Setup automatic token refresh on 401 errors
setupRefreshTokenInterceptor(Axios);
